import type { DocumentListItem } from './contract';

export interface DocumentListItemGroup {
  key: string;
  label: string;
  items: DocumentListItem[];
}

/**
 * Groups document-list items the same way RhfDocumentList renders them.
 * Shared so matrix footprint and adapter stay in sync.
 */
export function buildDocumentListGroups(
  items: DocumentListItem[],
  filterGroup?: string,
  groupOrder?: string[],
): DocumentListItemGroup[] {
  const filtered = filterGroup
    ? items.filter((item) => item.groupKey === filterGroup)
    : items;

  if (filtered.length === 0) return [];

  if (filterGroup) {
    return [{ key: filterGroup, label: '', items: filtered }];
  }

  const grouped = new Map<string, DocumentListItem[]>();
  for (const item of filtered) {
    const key = item.groupKey ?? 'ungrouped';
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key)!.push(item);
  }

  const result: DocumentListItemGroup[] = [];

  if (groupOrder && groupOrder.length > 0) {
    for (const key of groupOrder) {
      if (grouped.has(key)) {
        result.push({ key, label: key, items: grouped.get(key)! });
        grouped.delete(key);
      }
    }
  }

  for (const [key, groupItems] of grouped) {
    result.push({ key, label: key === 'ungrouped' ? '' : key, items: groupItems });
  }

  return result;
}

export function hasDocumentListItems(
  items: DocumentListItem[],
  filterGroup?: string,
  groupOrder?: string[],
): boolean {
  return buildDocumentListGroups(items, filterGroup, groupOrder).length > 0;
}
